var React = require('react');

function None (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26","cy":"26","r":"25","stroke":"#0E4F6A","strokeWidth":"2","key":0}),React.createElement("line",{"x1":"8.91829","y1":"7.50407","x2":"45.1814","y2":"43.7672","stroke":"#0E4F6A","strokeWidth":"2","key":1})]);
}

None.defaultProps = {"width":"52","height":"52","viewBox":"0 0 52 52","fill":"none"};

module.exports = None;

None.default = None;
